import React from 'react';
import { useQuery } from 'react-query';
import PropTypes from 'prop-types'
import Persona from '../personas/Persona.js'
import Form from 'react-bootstrap/Form';

function Select ({ setId, id }) {
  const { isLoading, error, data } = useQuery('personas', () => Persona.list(), {
    placeholderData: []
  })

  function sort(i) {
    return i.sort((a, b) => {
      var nameA = a.first_name.toUpperCase();
      var nameB = b.first_name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
      return 0;
    })
  }

  if (isLoading) {
    return 'Loading...'
  }

  if (error) {
    return 'An error has occurred: ' + error.message
  }

  return (
    <Form.Control
      disabled={typeof setId !== "function"}
      as="select"
      value={id}
      onChange={e => setId(parseInt(e.target.value))}
    >
      <option>-</option>
      {sort(data).map((persona) => (
        <option key={persona.id} value={persona.id}>{persona.first_name} {persona.last_name}</option>
      ))}
    </Form.Control>
  )
}

Select.propTypes = {
  setIndustryId: PropTypes.bool
}

export default Select